// De KPI-iconen wonen in ui-kit/kpi-icons.mjs (portaalplan U5, EEN bron); dit pad
// blijft voor de bestaande CRM-lezers (lib.js, het bord, de director-matrices).
export * from '../ui-kit/kpi-icons.mjs';
